module.exports = __webpack_public_path__ + "static/img/icons8-join-480.b989e5d1.png";